import React from 'react'
import { AuthRouteImport } from './Import'
import PageNotFound from './PageNotFound'
const { RoutesMap, Main, Login, ParticipantSignUp, OrganizerSignUp, ForgotPassword, EventList, EventDetails, AboutUs, PrivacyPolicy, RefundCancellation, TermsConditions, ShippingDelivery, HelpSupport } = AuthRouteImport

const AuthRoute = () => {
    return [
        {
            path: RoutesMap.LANDING_PAGE.path,
            element: <Main />
        },
        {
            path: RoutesMap.LOGIN.path,
            element: <Login />
        },
        {
            path: RoutesMap.PARTICIPANT_SIGN_UP.path,
            element: <ParticipantSignUp />
        },
        {
            path: RoutesMap.ORGANIZATION_SIGN_UP.path,
            element: <OrganizerSignUp />
        },
        {
            path: RoutesMap.FORGOT_PASSWORD.path,
            element: <ForgotPassword />
        },
        {
            path: RoutesMap.EVENT_LIST.path,
            element: <EventList />
        },
        {
            path: RoutesMap.EVENT_DETAILS.path,
            element: <EventDetails />
        },

        {
            path: RoutesMap.PRIVACY_POLICY.path,
            element: <PrivacyPolicy />
        },
        {
            path: RoutesMap.PRIVACY_POLICY_APP.path,
            element: <PrivacyPolicy />
        },
        {
            path: RoutesMap.REFUND_CANCELLATION.path,
            element: <RefundCancellation />
        },
        {
            path: RoutesMap.ABOUT_US.path,
            element: <AboutUs />
        },
        {
            path: RoutesMap.TERMS_CONDITIONS.path,
            element: <TermsConditions />
        },
        {
            path: RoutesMap.TERMS_CONDITIONS_APP.path,
            element: <TermsConditions />
        },
        {
            path: RoutesMap.SHIPPING_DELIVERY.path,
            element: <ShippingDelivery />
        },
        {
            path: RoutesMap.HELP_SUPPORT.path,
            element: <HelpSupport />
        },

        {
            path: RoutesMap.UNKNOWN_PATH.path,
            element: <PageNotFound />
        },
    ]
}

export default AuthRoute;